import scrollToSection from 'components/subjectSite/scrollToSection';
import React from 'react';

/**
 * The hero's round arrow, which scrolls to the page's first panel
 */
const LessonDownArrow: React.FC = () => (
  <a
    className="DownArrow"
    href="#Panel_One"
    aria-label="Scroll down"
    onClick={(event) => {
      event.preventDefault();
      scrollToSection(document.getElementById('Panel_One'), 600);
    }}
  ></a>
);

export default LessonDownArrow;
